import { render, staticRenderFns } from "./RewardsLeaderboardView.vue?vue&type=template&id=2214d59d&scoped=true&"
import script from "./RewardsLeaderboardView.vue?vue&type=script&lang=js&"
export * from "./RewardsLeaderboardView.vue?vue&type=script&lang=js&"
import style0 from "./RewardsLeaderboardView.vue?vue&type=style&index=0&id=2214d59d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2214d59d",
  null
  
)

export default component.exports